/**
 * Texts for User Training page - Finnish
 */
export const userTrainingPageText = {
    title: 'Käyttäjäkoulutus - CamAPS FX',
    titleMeta: 'Kattavat koulutusresurssit CamAPS FX -käyttäjille',
    descriptionMeta: 'Pääsy täydellisiin koulutusmateriaaleihin, video-opastuksiin, käyttöohjeisiin ja webinaareihin, jotka auttavat saamaan kaiken irti CamAPS FX:stä.',
    keywords:
        'camaps fx käyttäjäkoulutus, camaps koulutus, diabetes koulutus, insuliinipumppu koulutus, käyttöopas, video-opastukset',
    localeMeta: 'fi_fi',

    mainHeader: 'Käyttäjäkoulutus',
    mainSubHeader: 'Suorita välttämätön sovelluksensisäinen koulutus ennen CamAPS FX -sovelluksen käyttöä.',

    gettingStartedHeader: 'Aloittaminen',
    step1Title: '<strong>Vaihe 1:</strong><br/>Lataa sovellus',
    step2Title: '<strong>Vaihe 2:</strong><br/>Luo tili',
    step3Title: '<strong>Vaihe 3:</strong><br/>Aloita välttämätön sovelluksensisäinen koulutus',
    step4Title: '<strong>Vaihe 4:</strong><br/>Yhdistä valitsemasi pumppu ja CGM (hoitotiimisi hyväksynnällä) tai tutustu sovellukseen <strong>virtuaalisessa tilassa</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Tarvitsetko apua sovelluksen asentamisessa?',
    supportSectionText: 'Käy tukiosiossamme saadaksesi ohjeita',
    supportButtonText: 'SUPPORT',
    findOutMoreButtonText: 'LUE LISÄÄ',

    additionalResourcesTitle: 'Lisäresurssit',
    additionalResourcesSubtitle: 'Opi vaiheittaisilla visualisoinneilla tai katso asiantuntijoiden pitämiä istuntoja sovelluksen käytöstä.',
    
    animationsTitle: 'Animaatiot',
    animationsDescription: 'Dana-insuliinipumppua on tällä hetkellä saatavilla kaupallisesti vain CamAPS FX -sovelluksen kanssa Isossa-Britanniassa. Kaikki Danaan liittyvät resurssit ovat siksi saatavilla vain englanniksi.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinaarit',
    webinarsDescription: 'Nämä webinaarit sopivat tyypin 1 diabetesta sairastaville, heidän perheilleen ja hoitajilleen sekä opettajille, koulutuksen tukihenkilöstölle ja terveydenhuollon ammattilaisille.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Tietolomakkeet',
    factsheetsDescription: 'Dana-insuliinipumppua on tällä hetkellä saatavilla kaupallisesti vain CamAPS FX -sovelluksen kanssa Isossa-Britanniassa. Kaikki Danaan liittyvät resurssit ovat siksi saatavilla vain englanniksi.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Sovelluksensisäinen koulutus',
    inAppTrainingText: 'Aloita CamAPS FX -sovellukseen integroidusta olennaisesta koulutuksesta. Tämä interaktiivinen koulutus opastaa sinut läpi kaikkien tärkeimpien toimintojen, jotka sinun tulee tietää.<br/><br/><strong>Käyttö:</strong> Lataa CamAPS FX -sovellus ja luo tili aloittaaksesi sovelluksensisäisen koulutuksen.',

    gettingStartedText: '<strong>Vaihe 1:</strong> Lataa CamAPS FX -sovellus laitteesi sovelluskaupasta<br/><strong>Vaihe 2:</strong> Luo tilisi<br/><strong>Vaihe 3:</strong> Suorita sovelluksensisäiset koulutusmoduulit<br/><strong>Vaihe 4:</strong> Yhdistä insuliinipumppusi ja CGM<br/><strong>Vaihe 5:</strong> Aloita CamAPS FX -matkasi',

    trainingResourcesHeader: 'Lisäkoulutusresurssit',
    videoTutorialsText: 'Video-opastukset',
    videoTutorialsDesc: 'Katso vaiheittaiset video-oppaat, jotka kattavat asennuksen, päivittäisen käytön ja vianmäärityksen.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Käyttöoppaat ja dokumentaatio',
    userGuidesDesc: 'Lataa kattavat PDF-oppaat ja pika-ohjeet.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Live-webinaarit',
    webinarsDesc: 'Osallistu asiantuntijoiden vetämiin koulutuksiin ja kysymys-vastaus -tilaisuuksiin.',

    needHelpHeader: 'Tarvitsetko apua?',
    needHelpTextStart: 'Jos tarvitset apua tai sinulla on kysyttävää, käy',
    supportLinkText: 'Tuki',
    needHelpTextEnd: '-sivullamme saadaksesi lisäapua ja yhteystietoja.'
};

